import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Phone from '@material-ui/icons/Phone'
import { useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

export const Header = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

    return (
        <AppBar position="static" className={classes.appbar}>
            <Toolbar >
                <Typography variant="h6" className={classes.title}>
                    Hedis Bilverkstad
                </Typography>
                  <Button 
                    href="tel:070-4040223"
                    startIcon={<Phone className={classes.icon}/>}
                  >
                    { <p className={classes.phonetext}><a href="tel: 070-4040223"/>070-404 02 23</p> }
                  </Button>
            </Toolbar>
        </AppBar>
    )
}

const useStyles = makeStyles({
  title: {
    color: 'white',
    flexGrow: 1
  },
  icon: theme => ({
    color: theme.palette.icons.main
  }),
  buttonwrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignSelf: 'end'    
  },
  appbar: theme => ({
    backgroundColor: theme.palette.primary.main,
    flex: '0 0 auto'
  }),
  phonetext: {
    fontSize: '1rem'
  }
})